import React from "react";

export const QuotaInput = ({
  id,
  label,
  value,
  onChange,
  errors = [],
  type = "text",
  min,
  max,
  t,
}) => {
  return (
    <div className={errors.length ? "col validated" : "col"}>
      <label htmlFor={id}>{t(label)}</label>
      <input
        id={id}
        type={type}
        min={min}
        max={max}
        className={errors.length ? "form-control is-invalid" : "form-control"}
        value={value}
        onChange={onChange}
      />
      {errors.length > 0 &&
        errors.map((error, index) => (
          <div key={index} className="invalid-feedback">
            {error}
          </div>
        ))}
    </div>
  );
};
